export default __webpack_public_path__ + "static/media/cpv_44_materials-industry-sector.a9e4c855.svg";